import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'
import { QA_NAME_DASHBOARD_BIRDVIEW_DRAG_HANDLE } from '../../DashboardBirdview.constants.qa'

import * as styles from './BirdviewCardDragHandle.module.css'

import DragIcon from '../../../../icons/drag-and-drop.svg'

function BirdviewCardDragHandle({ dragHandleProps }) {
  return (
    <IconNG
      {...dragHandleProps}
      Icon={DragIcon}
      className={styles.dragHandle}
      color={ICON_COLOR.TextDisabledColor}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_DRAG_HANDLE}
      size={ICON_HEIGHT_16}
    />
  )
}

export default BirdviewCardDragHandle
